/* eslint-disable import/prefer-default-export */

export const TRACKER_ENABLED =
  typeof window === 'undefined' &&
  (process.env.TRV_FED_SPA_ENVIRONMENT !== 'development' ||
    process.env.TRV_FED_SPA_DX_DISABLE_TRACKING !== 'TRUE');
